export interface MParticleSDK {
  init(id?: string, config?: object): void
  logEvent: (name: string, type: string, data: Record<string, unknown>) => void
  logPageView: (
    name: string,
    data: Record<string, unknown>,
    customFlags: Record<string, unknown>
  ) => void
  EventType: Record<string, string>
}
interface MParticleEventData {
  application_transition_type?: string
  timestamp_unixtime_ms: number
  session_uuid: string
  session_start_unixtime_ms: number
  custom_attributes?: string | null
  location?: string | null
  source_message_id: string
  custom_event_type?: string
  custom_flags?: unknown
  event_name?: string
  screen_name?: string
}

export interface MParticleEvent {
  is_first_run?: boolean
  is_upgrade?: boolean
  launch_referral?: string
  event_type: string
  data: MParticleEventData
}

export interface MParticleBatch {
  events: Array<MParticleEvent>
}

// https://docs.mparticle.com/developers/server/json-reference/#events
export const BLOCKED_MPARTICLE_EVENT_TYPES = {
  APPLICATION_STATE_TRANSITION: 'application_state_transition',
  SESSION_START: 'session_start',
  SESSION_END: 'session_end',
  UNINSTALL: 'uninstall',
}
